import { useState } from 'react'
import { toast } from '@dd3tech/wiggui/Toast'
import { getGeneratedPropertiesXlsx } from '../../../services/properties.services'
import { useModalDownloadPropertiesXlsxStore } from '../../../store'
import { removeToasts } from '../../../../utils/src/remove-toasts'
import { openXlsx } from '../../../../utils/src/download-xlsx'

export const useModalDownloadPropertiesXlsx = () => {
  const [isLoading, setIsLoading] = useState(false)
  const [selectedStatuses, setSelectedStatuses] = useState<{
    PUBLISHED: boolean
    NOT_PUBLISHED: boolean
  }>({
    PUBLISHED: true,
    NOT_PUBLISHED: false
  })

  const modalDownloadPropertiesXlsx = useModalDownloadPropertiesXlsxStore(
    (state) => state.modalDownloadPropertiesXlsx
  )
  const setModalDownloadPropertiesXlsx = useModalDownloadPropertiesXlsxStore(
    (state) => state.setModalDownloadPropertiesXlsx
  )

  const handleGetGeneratedPropertiesXlsx = async () => {
    const statuses = Object.entries(selectedStatuses)
      .filter(([, isSelected]) => isSelected)
      .map(([status]) => status)

    if (statuses.length === 0) {
      toast({
        type: 'error',
        title: 'Selecciona al menos un estado'
      })
      return
    }

    setIsLoading(true)

    toast({
      position: 'bottom-right',
      autoClose: false,
      closeOnClick: false,
      hideProgressBar: true,
      type: 'info',
      title: 'Exportar propiedades',
      description: 'Preparando documento...',
      customIcon: {
        name: 'progress_activity',
        class: 'animate-spin text-notif-blue'
      }
    })

    onClose()

    const { isSuccess, data } = await getGeneratedPropertiesXlsx({
      statuses
    })

    setIsLoading(false)
    removeToasts()

    if (isSuccess && data) {
      modalDownloadPropertiesXlsx?.onSuccess?.()

      openXlsx(data.file, data.fileName, data.fileType)

      return
    }

    toast({
      type: 'error',
      title: 'No se pudo generar el archivo'
    })
  }

  const onClose = () => {
    setModalDownloadPropertiesXlsx({
      isOpen: false
    })
  }
  const handleStatusChange = (status: 'PUBLISHED' | 'NOT_PUBLISHED') => {
    setSelectedStatuses((prev) => {
      const newValue = !prev[status]
      const otherStatus = status === 'PUBLISHED' ? 'NOT_PUBLISHED' : 'PUBLISHED'

      // Si intenta desmarcar y el otro ya está desmarcado, no permitir
      if (!newValue && !prev[otherStatus]) {
        return prev
      }

      return {
        ...prev,
        [status]: newValue
      }
    })
  }

  return {
    handleGetGeneratedPropertiesXlsx,
    onClose,
    isLoading,
    selectedStatuses,
    handleStatusChange
  }
}
